module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Payment #{{id}}","success":"Payment updated successfully"},"et":{"title":"Payment #{{id}}","success":"Payment updated successfully"},"ru":{"title":"Payment #{{id}}","success":"Payment updated successfully"}}')
  delete Component.options._Ctor
}
